import { z } from 'zod/v4';

export const EMBEDDING_MODEL_VALUES = [
  'TEXT_EMBEDDING_ADA_002',
  'TEXT_EMBEDDING_3_LARGE',
] as const;

export const GenerateEmbeddingsBodySchema = z.object({
  count: z.number().int().positive(),
  model: z.enum(EMBEDDING_MODEL_VALUES),
  composedOf: z
    .array(z.string())
    .default([
      'officialName',
      'displayName',
      'countryName',
      'facilityProcesses',
    ]),
});

export type GenerateEmbeddingsBody = z.infer<
  typeof GenerateEmbeddingsBodySchema
>;

export const GenerateEmbeddingsResponseSchema = z.object({
  remainingEntitiesToGenerateCount: z.number(),
  vectorEmbeddingsGeneratedCount: z.number(),
  page: z.number(),
  count: z.number(),
});

export type GenerateEmbeddingsResponse = z.infer<
  typeof GenerateEmbeddingsResponseSchema
>;
